<script>
import { genericForms } from '@shared/mixins/forms';

export default {
  mixins: [genericForms],
  form: {
    name: {
      label: 'Titre',
      type: 'text',
      column: 'is-12 pb-0',
      inputAttrs: {
        required: true,
        maxlength: 128,
      },
    },
    draft: {
      switchLabel: 'Mettre en brouillon',
      type: 'switch',
      column: 'is-12 pt-0',
    },
    /* description: {
      label: 'Description',
      type: 'editor',
      column: 'is-12 pt-0',
      inputAttrs: {
        maxlength: 512,
      },
    }, */
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      trainingItem: {
        id: this.item.id,
        name: this.item.name,
        draft: this.item.draft,
        description: this.item.description,
        type: 'SECTION',
      },
    };
  },
  computed: {
    currentTraining() {
      return this.$store.state.trainings.current;
    },
    emptyQuizzesInSection() {
      if (!this.item.id || !this.currentTraining) return [];
      const section = this.currentTraining.items.find((i) => i.id === this.item.id);
      if (!section || !section.children) return [];
      return section.children.filter(
        (child) => child.type === 'QUIZ' && (child.published_questions_count ?? 0) === 0,
      );
    },
  },
  methods: {
    doSave(emptyQuizzes = []) {
      const { uuid } = this.currentTraining;
      const trainingItem = { ...this.trainingItem };
      const trainingItemId = this.trainingItem.id;

      this.isLoading = true;

      const promise = trainingItemId
        ? this.$store.dispatch('trainings/updateItem', { uuid, trainingItemId, trainingItem })
        : this.$store.dispatch('trainings/addItem', { uuid, trainingItem });

      return promise
        .then(() => {
          this.$emit('close');
          // Chapitre publié malgré un quiz sans question : on informe plutôt que
          // de bloquer (le quiz, lui, reste en brouillon).
          if (emptyQuizzes.length > 0) {
            this.notifyEmptyQuizzes(emptyQuizzes);
          } else {
            this.$showMessage.success();
          }
        })
        .finally(() => (this.isLoading = false));
    },
    // Publier un chapitre ne publie pas ses quiz enfants : un quiz sans question
    // ne peut pas être publié et reste en brouillon. On prévient l'utilisateur.
    notifyEmptyQuizzes(emptyQuizzes) {
      const count = emptyQuizzes.length;
      const names = emptyQuizzes.map((q) => `<strong>${q.name}</strong>`).join(', ');
      const plural = count > 1;
      this.$buefy.dialog.alert({
        type: 'is-warning',
        title: 'Chapitre publié',
        message: `Le chapitre a bien été publié.<br><br>En revanche, ${plural ? 'les quiz suivants ne contiennent' : 'le quiz suivant ne contient'} aucune question : ${names}. ${plural ? 'Ils n\'ont' : 'Il n\'a'} donc pas été publié${plural ? 's' : ''} et ${plural ? 'restent' : 'reste'} en brouillon. Ajoutez-${plural ? 'leur' : 'lui'} des questions pour ${plural ? 'les' : 'le'} publier.`,
        confirmText: 'OK',
      });
    },
    handle() {
      const isPublishing = this.item.draft && !this.trainingItem.draft;
      const emptyQuizzes = isPublishing ? this.emptyQuizzesInSection : [];
      this.doSave(emptyQuizzes);
    },
  },
};
</script>

<template>
  <form class="modal-card" @submit.prevent="dataIsValid(isLoading) && handle()">
    <header class="modal-card-head">
      <h2 class="modal-card-title">
        <template v-if="trainingItem.id">
          Modifier le chapitre
        </template>
        <template v-else>
          Ajouter un chapitre
        </template>
      </h2>
      <button
        type="button"
        class="modal-close is-large"
        aria-label="Fermer"
        @click="$emit('close')"
      />
    </header>
    <div class="modal-card-body">
      <div class="columns is-multiline">
        <div v-for="(field, k) in $options.form" :key="k" class="column" :class="field.column">
          <BaseField v-model="trainingItem[k]" :field="field" />
        </div>
      </div>
    </div>
    <footer class="modal-card-foot is-justify-content-flex-end">
      <div class="buttons">
        <b-button type="is-text" @click="$emit('close')">
          Fermer
        </b-button>
        <b-button type="is-primary" native-type="submit" :loading="isLoading">
          Enregistrer
        </b-button>
      </div>
    </footer>
  </form>
</template>
